<template>
  <svg
    id="icon-circle-x"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    :width="width"
    :height="height"
    viewBox="0 0 17 18"
  >
    <path
      :fill="fill"
      d="M8.93 17.07C4.516 17.07.86 13.422.86 9 .86 4.586 4.507.93 8.921.93 13.344.93 17 4.586 17 9c0 4.422-3.656 8.07-8.07 8.07Zm0-1.586A6.468 6.468 0 0 0 15.414 9a6.468 6.468 0 0 0-6.492-6.477A6.448 6.448 0 0 0 2.453 9a6.462 6.462 0 0 0 6.477 6.484Zm-2.57-3.203a.704.704 0 0 1-.712-.71.64.64 0 0 1 .22-.485L7.93 9.008l-2.063-2.07a.67.67 0 0 1-.219-.493c0-.39.313-.695.711-.695.196 0 .36.07.493.21l2.07 2.063 2.086-2.07a.67.67 0 0 1 .5-.219.7.7 0 0 1 .703.704c0 .187-.07.351-.211.492L9.93 9.008l2.062 2.07c.14.133.211.305.211.492 0 .399-.312.711-.703.711a.701.701 0 0 1-.508-.21l-2.07-2.063-2.055 2.062a.684.684 0 0 1-.508.211Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconCircleX",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
